import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export default function useErrorsTranslation() {
  const { t, i18n } = useTranslation("errors");

  const getErrorMessage = useCallback((code) => {
    if (!code)
      return t("error.unknown", "Ocorreu um erro inesperado. Tente novamente.");

    const translation = t(code);

    if (translation === code) {
      return t("error.unknown", "Ocorreu um erro inesperado. Tente novamente.");
    }

    return translation;
  }, [t]);

  return {
    getErrorMessage,
    changeLanguage: i18n.changeLanguage,
  };
}
